<template>
  <div class="n35-three">
    <!-- 移动端loading -->
    <Loading v-if="isMobile && isLoading" />
    <!-- 主图 -->
    <CarMainBanner :is-mobile="isMobile"
      banner-name="N35° 雅丹"
      :banner-url="imgUrlPrefix + mainBanner"
      :title="mainTitle"
      :sub-title="subTitle"
      @pageLoad="pageLoad"
    />

    <!-- 图文混排组件 -->
    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList" mobile-font-color="light" />

    <!-- 上下布局组件: 上文字+下图片 -->
    <CarUpTxtDownImg :is-mobile="isMobile" :txt-img-obj="carUpTxtDownImgObject" />

    <!-- 图文混排组件 2 -->
    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList2" />

    <!-- 4行3列 -->
    <div v-if="isMobile" class="sec_4">
      <div class="sec_4_txt">
        <h5>212METTA<br>3-DOORMODEL</h5>
        <p>COLORS AND SPECIAL EDITIONS</p>
      </div>
      <div class="sec_4_box">
          <div class="sec_4_img">
          <img class="img-cover" :src="`${imgUrlPrefix}m-sec4_1.jpg`" alt="" />
        </div>
      </div>
    </div>
    <div v-else>
      <img class="img-cover" :src="`${imgUrlPrefix}sec4_1.jpg`" alt="" />
    </div>

    <!-- 车辆系列展示组件-1行3列 -->
    <CarSeriesComponent :car-series-obj="carSeriesObj" />

    <!-- 用户社群共创组件-多行多列 -->
    <!-- <CarCommunityComponent :car-community-obj="carCommunityObj" /> -->

    <!-- 底部生活方式组件 -->
    <CarLifeComponent :bg-img="carLifeBg" />
  </div>
</template>

<script>
import { checkIsMobile } from '../utils/tools.js'
import Loading from '../components/Loading.vue'
import CarMainBanner from '../components/CarMainBanner.vue'
import CarTxtInImgList from '../components/CarTxtInImgList.vue'
import CarUpTxtDownImg from '../components/CarUpTxtDownImg.vue'
import CarSeriesComponent from '../components/CarSeriesComponents.vue'
// import CarCommunityComponent from '../components/CarCommunityComponent.vue'
import CarLifeComponent from '../components/CarLifeComponent.vue'
export default {
  components: {
    Loading,
    CarMainBanner,
    CarTxtInImgList,
    CarUpTxtDownImg,
    CarSeriesComponent,
    // CarCommunityComponent,
    CarLifeComponent,
  },
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  computed: {
    mainBanner() {
      return this.isMobile ? 'm-N30ThreeMain.jpg' : 'N30ThreeMain.jpg'
    },
    mainTitle() {
      return this.isMobile ? 'N30° 致敬<br>每一段<br>传奇征途' : 'N30° 致敬每一段传奇征途'
    },
    subTitle() {
      return this.isMobile ? '短轴硬派潮玩座驾<br>时尚搭子' : '短轴硬派潮玩座驾・时尚搭子'
    },
    carLifeBg() {
      return this.isMobile ? '/assets/images/m-n30-life-bg.jpg' : '/assets/images/n30-life-bg.jpg'
    },

    // 上下布局: 上文字+下图片数据
    carUpTxtDownImgObject() {
      return {
        title: this.isMobile ? '短轴硬派潮玩座驾<br>时尚搭子' : '短轴硬派潮玩座驾・时尚搭子',
        desc: this.isMobile ? '专为喜欢个性出街、追求颜值穿搭<br>又想偶尔玩越野的年轻用户打造' : '专为喜欢个性出街、追求颜值穿搭又想偶尔玩越野的年轻用户打造',
        imgList: [this.imgUrlPrefix + 'sec2_1.jpg'],
        mobileImg: this.imgUrlPrefix + 'm-sec2_1.jpg',
      }
    },

    // 图文混排数据 2
    carTxtInImgList2() {
      return [
        {
          tag: '',
          title: '经典硬派<br>姿态比例设计',
          desc: '标志性方盒车身，勾勒硬派经典轮廓<br>圆形复古大灯致敬212 与威利斯时代',
          img: this.imgUrlPrefix + 'sec3_1.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_1.jpg',
          txtLayout: 'left-top',
        },
        {
          tag: '',
          title: '短轴硬派潮玩座驾<br>时尚搭子',
          desc: '专为喜欢个性出街、追求颜值穿搭<br>又想偶尔玩越野的年轻用户打造',
          img: this.imgUrlPrefix + 'sec3_2.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_2.jpg',
          txtLayout: 'left-top',
        },
        {
          tag: '',
          title: '机械感力量美学',
          desc: '突出的轮眉、外露的门铰链、结实的侧踏板<br>不遮掩，不修饰<br>纯粹的功能主义设计',
          img: this.imgUrlPrefix + 'sec3_3.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_3.jpg',
          txtLayout: 'left-top',
        },
        {
          tag: '',
          title: '硬核能力<br>支撑所有的热爱与想象',
          desc: this.isMobile ? 
            '全地形大胎加持<br>不管是城市潮游、山野露营还是非铺装路穿越<br>说走就走，不设限你的玩乐边界' : '全地形大胎加持，不管是城市潮游、山野露营还是非铺装路穿越<br>说走就走，不设限你的玩乐边界',
          img: this.imgUrlPrefix + 'sec3_4.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_4.jpg',
          color: 'light',
          txtLayout: 'left-top',
        },
        {
          tag: '',
          title: '',
          desc: '',
          img: this.imgUrlPrefix + 'sec3_5.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_5.jpg',
          txtLayout: 'none',
        },
        // 0423新增
        {
          tag: '',
          title: this.isMobile ? '可变好玩<br>解锁多元风格' : '可变好玩 解锁多元风格',
          desc: this.isMobile ? 
            '十余种车身主色 + 专属顶篷配色自由混搭<br>从撞色潮酷到同色系高级感<br>打造专属你的定制化座驾<br>每一辆都是独一无二的风格表达<br>彻底告别 “一台车一种风格” 的局限<br>车随你变，心情随你定，怎么潮怎么玩<br>把出行变成一场随时换装的时尚秀' : '十余种车身主色 + 专属顶篷配色自由混搭，从撞色潮酷到同色系高级<br>感，打造专属你的定制化座驾，每一辆都是独一无二的风格表达<br>彻底告别 “一台车一种风格” 的局限，车随你变，心情随你定，怎么<br>潮怎么玩，把出行变成一场随时换装的时尚秀',
          img: this.imgUrlPrefix + 'sec3_6.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_6.jpg',
          txtLayout: 'center-top',
        },
        {
          tag: '',
          title: '',
          desc: '',
          img: this.imgUrlPrefix + 'sec3_7.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_7.jpg',
          txtLayout: 'none',
        },
        {
          tag: '',
          title: '',
          desc: '',
          img: this.imgUrlPrefix + 'sec3_8.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_8.jpg',
          txtLayout: 'none',
        },
        {
          tag: '',
          title: '',
          desc: '',
          img: this.imgUrlPrefix + 'sec3_9.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_9.jpg',
          txtLayout: 'none',
        },
        {
          tag: '',
          title: '',
          desc: '',
          img: this.imgUrlPrefix + 'sec3_10.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_10.jpg',
          txtLayout: 'none',
        },
      ]
    },



  },
  data() {
    const imgUrlPrefix = '/assets/images/n30ThreeDoors/'
    const imgUrlPrefix2 = '/assets/images/n30Loki/'
    return {
      isLoading: true,
      isMobile: false,
      imgUrlPrefix, // 图片地址前缀
      // 图文混排数据
      carTxtInImgList: [
        {
          tag: '',
          title: 'N30° 雅丹',
          desc: '以西域大地之名，铸旷野穿行之躯<br>风蚀千年的硬朗，即是车身的线条',
          img: imgUrlPrefix + 'sec1_1.jpg',
          mobileImg: imgUrlPrefix + 'm-sec1_1.jpg',
          txtLayout: 'center-top2',
        }
      ],
      
      // 车辆系列数据
      carSeriesObj: {
        logo: imgUrlPrefix2 + 'series-logo.png',
        desc: '以「高端定制」为核，共创专属格调',
        title: 'CLASSIC N30° 系列',
        series: 'CLASSIC',
        carList: [
          { img: imgUrlPrefix2 + 'sec7_1.png', name: 'N30° 环球', link: 'N30Cross'},
          { img: imgUrlPrefix2 + 'sec7_2.png', name: 'N30° 洛基', link: 'N30Loki'},
          { img: imgUrlPrefix2 + 'sec7_3.png', name: 'N30° 雅丹', link: ''},
        ]
      },
      // 用户社群共创数据
      carCommunityObj: {
        title: 'N30°用户社群共创',
        desc: 'N30°家族的模块化设计架构，天生为多元探索而生<br>它既承载了标准化量产的通用实力，量身打造专属越<br>野解决方案，陪你奔赴每一种远方。',
        imgList: [
          imgUrlPrefix2 + 'sec8_1.png', imgUrlPrefix2 + 'sec8_2.png', imgUrlPrefix2 + 'sec8_3.png', imgUrlPrefix2 + 'sec8_4.png',
          imgUrlPrefix2 + 'sec8_5.png', imgUrlPrefix2 + 'sec8_6.png', imgUrlPrefix2 + 'sec8_7.png', imgUrlPrefix2 + 'sec8_8.png',
          imgUrlPrefix2 + 'sec8_9.png', imgUrlPrefix2 + 'sec8_10.png', imgUrlPrefix2 + 'sec8_11.png', imgUrlPrefix2 + 'sec8_12.png',
        ]
      },
    }
  },
  methods: {
    checkDevice() {
      this.isMobile = checkIsMobile()
    },
    pageLoad() {
      this.isLoading = false
    }
  },
}
</script>

<style lang="less" scoped>
.n35-three{
  font-weight: @fw2;
  font-family: 'TsangerYunHei', sans-serif;
}
@media (max-width: @mobile-width) {
  .n35-three{
    .sec_4 {
      background-color: #ECECEC;
      .sec_4_box {
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
        &::-webkit-scrollbar { display: none; }
        .sec_4_img {
          width: 278.1vw;
          height: auto;
        }
      }
      .sec_4_txt {
        color: #212020;
        text-align: center;
        padding-top: 19.73vw;
        margin-bottom: 8vw;
        h5{
          font-size: 8.53vw;
          font-weight: @fw1;
          line-height: 1.2;
        }
        p{
          font-size: 4.26vw;
          font-weight: @fw2;
          margin-top: 1.6vw;
        }
      }
    }
  }
}
</style>